<template>
    <div>
      <v-card>
        <v-card-title><span class="pink--text">Location Details</span>
          <v-spacer></v-spacer> <v-icon class="red--text" @click="$emit('closeInfo')">mdi-close</v-icon></v-card-title>
        <v-form @submit.prevent="submitForm" class="pa-2">
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.country" multiple :items="LookupArr(dropDownList?.countryList)"
              item-text="text" item-value="value" label="Country"></v-autocomplete>
            </v-col>    
            <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.state" multiple  :items="LookupArr(dropDownList?.stateList)"
              item-text="text" item-value="value" label="State"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete v-model="partnerpreferenceList.district" multiple :items="LookupArr(dropDownList?.districtList)"
              item-text="text" item-value="value" label="District"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12" class="d-flex justify-end">
            <v-btn type="submit" class="primary elevation-0"> Submit</v-btn>
          </v-col>
          </v-row>
        </v-form>
      </v-card>
    </div>
  </template>
  <script>
  
  export default {
    data() {
      return {
        Indicator: "location",
      };
    },
    props: {
      dropDownList:{},partnerpreferenceList:[]
    },
    methods:{
      submitForm() {


this.$emit("location", this.Indicator)
// Handle form submission logic here, e.g., send data to an API or update the state
},
    }
     
  };
  </script>
  